import { gql } from "@apollo/client"

export const GET_WALLET_BY_ID = gql`
  query GetWalletById($userId: ID, $userType: String, $walletId: ID) {
    getWalletById(user_id: $userId, user_type: $userType, wallet_id: $walletId) {
      id
      user_id
      company_commission
      blacklane_commission
      stripe_id
      account_id
      card_token
      bank_token
      name
      payment_method
      email
      balance
      credit
      credit_limit
      type
      enabled
      cards {
        id
        exp_month
        exp_year
        last4
        brand
        funding
      }
      bank_accounts {
        id
        account_holder_name
        bank_name
        last4
        routing_number
        status
        country
        currency
      }
      members {
        id
        first_name
        last_name
        gender
        balance
        status
      }
    }
  }
`